import React, { useEffect } from 'react';
import { Select } from 'antd';
import GetProductTypes from '../../functions/reference/getProductType';

const { Option } = Select;

const ProductTypeSelect = ({ onChange, value }) => {
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    useEffect(() => {
         fetchList()
    },[])
    const fetchList = async () => {
         setLoading(true)
         const response=await GetProductTypes()
         if(response){
           var data=response.map(e=>({id:e.id,name:e.name}))
           if(true)// add extra select option
              data=[{id:null,name:'сонго'},...data] 
           setData(data)
           if(value==null) onChange(data[0].id)
        }
    }
    return (
        <Select
            placeholder="Select a product type"
            onChange={onChange}
            value={value}
            loading={loading}
            style={{ width: '100%' }}
        >
            {data.map((item) => (
                <Option key={item.id} value={item.id}>
                    {item.name}
                </Option>
            ))}
        </Select>
    );
};

export default ProductTypeSelect;